import BLEPin from './BLEPin'

export default BLEPin
